export default "__VITE_ASSET__kngYsjA5__"